/**
 * Two-letter avatar initials from a display name; '—' fallback. Cyrillic-aware,
 * so «Мария Ковалёва» renders as «МК». Moved here from the inspectors page
 * (AUT-542) so «Специалисты» does not reach into another page's `_lib`.
 */
export const initials = (name: string | null): string => {
  if (!name) return '—';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0];
  if (!first) return '—';
  const second = parts[1];
  if (!second) return first.slice(0, 2).toLocaleUpperCase();
  return ((first[0] ?? '') + (second[0] ?? '')).toLocaleUpperCase();
};
